// Import necessary modules
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../Image/logo.webp';
import { auth } from '../firebase';
import { setDoc, doc, collection, getDocs } from 'firebase/firestore';
import { db } from "../firebase";
import NewProject from './NewProject'; // Import the NewProject component
import { motion } from 'framer-motion'
import emoji from '../Image/emoji.png'

function Pro({ user, setIsLoggedIn, searchQuery  }) {
    const [projects, setProjects] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        // Function to fetch projects data
        const fetchProjects = async () => {
            const projectsCollection = collection(db, 'Projects');
            const projectsSnapshot = await getDocs(projectsCollection);
            const projectsData = projectsSnapshot.docs.map(doc => doc.data());
            setProjects(projectsData);
        };

        fetchProjects();

    }, []);


    const handleupdatecode = (project) => {
        if (user) {
            setIsLoggedIn(true);
            navigate(`/updatecode/${project.id}`, { state: { project } });
        } else {
            // If not logged in, redirect to login
            navigate('/home/login');
        }
    }

    const filteredProjects = projects.filter(project =>
        project.title.toLowerCase().includes(searchQuery.toLowerCase())
      );

    return (
        <>
            <div className="px-6 py-4 flex items-center justify-center rounded-xl border mt-8 border-gray-400 cursor-pointer group hover:border-gray-200">
                <p className='text-white group hover:text-gray-200' >Your Work</p>
            </div>

            <div className="w-full py-6 flex items-center justify-center gap-6 flex-wrap">

                {filteredProjects.map(project => (
                    // Only render projects belonging to the logged-in user
                    project.user.uid === user.uid && (
                        <motion.div key={project.id}
                            className='w-full cursor-pointer md:w-[450px] h-[375px] bg-secondary rounded-md p-4 flex flex-col items-center
             justify-center gap-4' onClick={() => handleupdatecode(project)}>
                            <div className="bg-primary w-full h-full rounded-md overflow-hidden" style={{ overflow: "Hidden", height: "100%" }}>
                                <iframe
                                    title='Result'
                                    srcDoc={project.output}
                                    style={{ border: "none", width: "100%", height: "100%" }}
                                />
                            </div>
                            <div className="flex items-center justify-start gap-3 w-full">
                                {/*for image*/}
                                <div className="w-14 h-14 flex items-center justify-center rounded-xl overflow-hidden
                            cursor-pointer bg-emerald-400">
                                    <p className="text-xl text-white font-semibold capitalize">{project.user.email[0]}</p>
                                </div>
                                {/* for title and name*/}
                                <div className="">
                                    <p className="text-white text-lg capitalize">{project.title}</p>
                                    <p className="text-primaryText text-sm capitalize">{project.user.displayName}</p>
                                </div>
                            </div>
                        </motion.div>
                    )
                ))}
            </div>
        </>
    );

}

export default Pro;
